import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import leadsSlice from './slices/leadsSlice';
import usersSlice from './slices/usersSlice';
import reportsSlice from './slices/reportsSlice';
import notificationsSlice from './slices/notificationsSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    leads: leadsSlice,
    users: usersSlice,
    reports: reportsSlice,
    notifications: notificationsSlice,
  },
});

export default store;